import { IconProps } from '@chakra-ui/react';
import { Icon } from '@diamond/shared/ui';
import { useId } from 'react';

export const ReasonCancelIcon = (props: IconProps) => {
  const maskId = useId();
  return (
    <Icon
      as="svg"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M10.0002 18.3568C9.77794 18.3568 9.56614 18.3151 9.36475 18.2318C9.16336 18.1484 8.97933 18.0304 8.81266 17.8776L2.12516 11.1901C1.97238 11.0234 1.85433 10.8394 1.771 10.638C1.68766 10.4366 1.646 10.2248 1.646 10.0026C1.646 9.78038 1.68766 9.5651 1.771 9.35677C1.85433 9.14844 1.97238 8.96788 2.12516 8.8151L8.81266 2.1276C8.97933 1.96094 9.16336 1.83941 9.36475 1.76302C9.56614 1.68663 9.77794 1.64844 10.0002 1.64844C10.2224 1.64844 10.4377 1.68663 10.646 1.76302C10.8543 1.83941 11.0349 1.96094 11.1877 2.1276L17.8752 8.8151C18.0418 8.96788 18.1634 9.14844 18.2397 9.35677C18.3161 9.5651 18.3543 9.78038 18.3543 10.0026C18.3543 10.2248 18.3161 10.4366 18.2397 10.638C18.1634 10.8394 18.0418 11.0234 17.8752 11.1901L11.1877 17.8776C11.0349 18.0304 10.8543 18.1484 10.646 18.2318C10.4377 18.3151 10.2224 18.3568 10.0002 18.3568ZM10.0002 16.6901L16.6877 10.0026L10.0002 3.3151L3.31266 10.0026L10.0002 16.6901ZM9.16683 10.8359H10.8335V5.83594H9.16683V10.8359ZM10.0002 13.3359C10.2363 13.3359 10.4342 13.2561 10.5939 13.0964C10.7536 12.9366 10.8335 12.7387 10.8335 12.5026C10.8335 12.2665 10.7536 12.0686 10.5939 11.9089C10.4342 11.7491 10.2363 11.6693 10.0002 11.6693C9.76405 11.6693 9.56614 11.7491 9.40641 11.9089C9.24669 12.0686 9.16683 12.2665 9.16683 12.5026C9.16683 12.7387 9.24669 12.9366 9.40641 13.0964C9.56614 13.2561 9.76405 13.3359 10.0002 13.3359Z"
          fill="currentColor"
        />
      </g>
    </Icon>
  );
};

export const FrozenStorageIcon = (props: IconProps) => {
  const maskId = useId();
  return (
    <Icon
      as="svg"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M6.33203 11.9026L4.61536 13.5859C4.49314 13.7082 4.34036 13.7693 4.15703 13.7693C3.9737 13.7693 3.82092 13.7026 3.6987 13.5693C3.56536 13.447 3.4987 13.2943 3.4987 13.1109C3.4987 12.9276 3.56536 12.7693 3.6987 12.6359L6.33203 10.0026V8.66927H4.9987L2.3487 11.3193C2.22648 11.4415 2.0737 11.5026 1.89036 11.5026C1.70703 11.5026 1.5487 11.4359 1.41536 11.3026C1.29314 11.1804 1.23203 11.0276 1.23203 10.8443C1.23203 10.6609 1.29314 10.5082 1.41536 10.3859L3.0987 8.66927H0.982031C0.793142 8.66927 0.637587 8.60538 0.515365 8.4776C0.393142 8.34983 0.332031 8.19149 0.332031 8.0026C0.332031 7.81371 0.39592 7.65538 0.523698 7.5276C0.651476 7.39983 0.809809 7.33594 0.998698 7.33594H3.0987L1.41536 5.63594C1.29314 5.51372 1.23203 5.36094 1.23203 5.1776C1.23203 4.99427 1.2987 4.83594 1.43203 4.7026C1.55425 4.58038 1.70703 4.51927 1.89036 4.51927C2.0737 4.51927 2.23203 4.58038 2.36536 4.7026L4.9987 7.33594H6.33203V6.0026L3.68203 3.36927C3.55981 3.24705 3.4987 3.09427 3.4987 2.91094C3.4987 2.7276 3.56536 2.56927 3.6987 2.43594C3.82092 2.31372 3.9737 2.2526 4.15703 2.2526C4.34036 2.2526 4.49314 2.31372 4.61536 2.43594L6.33203 4.1026V2.0026C6.33203 1.81372 6.39592 1.65538 6.5237 1.5276C6.65148 1.39983 6.80981 1.33594 6.9987 1.33594C7.18759 1.33594 7.34592 1.39983 7.4737 1.5276C7.60148 1.65538 7.66536 1.81372 7.66536 2.0026V4.1026L9.36536 2.43594C9.48759 2.31372 9.64036 2.2526 9.8237 2.2526C10.007 2.2526 10.1654 2.31372 10.2987 2.43594C10.4209 2.56927 10.482 2.7276 10.482 2.91094C10.482 3.09427 10.4209 3.24705 10.2987 3.36927L7.66536 6.0026V7.33594H8.9987L11.632 4.7026C11.7543 4.58038 11.907 4.51927 12.0904 4.51927C12.2737 4.51927 12.432 4.58594 12.5654 4.71927C12.6876 4.84149 12.7487 4.99427 12.7487 5.1776C12.7487 5.36094 12.6876 5.51372 12.5654 5.63594L10.8987 7.33594H12.9987C13.1876 7.33594 13.3459 7.39983 13.4737 7.5276C13.6015 7.65538 13.6654 7.81371 13.6654 8.0026C13.6654 8.19149 13.6015 8.34983 13.4737 8.4776C13.3459 8.60538 13.1876 8.66927 12.9987 8.66927H10.8987L12.5654 10.3859C12.6876 10.5082 12.7487 10.6609 12.7487 10.8443C12.7487 11.0276 12.6876 11.1804 12.5654 11.3026C12.432 11.4359 12.2737 11.5026 12.0904 11.5026C11.907 11.5026 11.7543 11.4359 11.632 11.3026L8.9987 8.66927H7.66536V10.0026L10.2987 12.6526C10.4209 12.7748 10.482 12.9276 10.482 13.1109C10.482 13.2943 10.4154 13.4526 10.282 13.5859C10.1598 13.7082 10.007 13.7693 9.8237 13.7693C9.64036 13.7693 9.48759 13.7082 9.36536 13.5859L7.66536 11.9026V14.0193C7.66536 14.2082 7.60148 14.3637 7.4737 14.4859C7.34592 14.6082 7.18759 14.6693 6.9987 14.6693C6.80981 14.6693 6.65148 14.6054 6.5237 14.4776C6.39592 14.3498 6.33203 14.1915 6.33203 14.0026V11.9026Z"
          fill="currentColor"
        />
      </g>
    </Icon>
  );
};

export const ChilledStorageIcon = (props: IconProps) => {
  const maskId = useId();
  return (
    <Icon
      as="svg"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M9.33333 5.33333V4H14.6667V5.33333H9.33333ZM5.33333 14C4.41111 14 3.625 13.675 2.975 13.025C2.325 12.375 2 11.5889 2 10.6667C2 10.1333 2.11667 9.63611 2.35 9.175C2.58333 8.71389 2.91111 8.32222 3.33333 8V4C3.33333 3.44444 3.52778 2.97222 3.91667 2.58333C4.30556 2.19444 4.77778 2 5.33333 2C5.88889 2 6.36111 2.19444 6.75 2.58333C7.13889 2.97222 7.33333 3.44444 7.33333 4V8C7.75556 8.32222 8.08333 8.71389 8.31667 9.175C8.55 9.63611 8.66667 10.1333 8.66667 10.6667C8.66667 11.5889 8.34167 12.375 7.69167 13.025C7.04167 13.675 6.25556 14 5.33333 14ZM3.33333 10.6667H7.33333C7.33333 10.3444 7.26389 10.0444 7.125 9.76667C6.98611 9.48889 6.78889 9.25556 6.53333 9.06667L6 8.66667V4C6 3.81111 5.93611 3.65278 5.80833 3.525C5.68056 3.39722 5.52222 3.33333 5.33333 3.33333C5.14444 3.33333 4.98611 3.39722 4.85833 3.525C4.73056 3.65278 4.66667 3.81111 4.66667 4V8.66667L4.13333 9.06667C3.87778 9.25556 3.68056 9.48889 3.54167 9.76667C3.40278 10.0444 3.33333 10.3444 3.33333 10.6667Z"
          fill="currentColor"
        />
      </g>
    </Icon>
  );
};

export const DryStorageIcon = (props: IconProps) => (
  <Icon
    as="svg"
    viewBox="0 -960 960 960"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M750-614q-27 27-62 41t-70 14q-35 0-69-13.5T488-614l-75-75q-15-15-34-22.5t-39-7.5q-20 0-39 7.5T267-689l-47 47q-12 12-28 11.5T164-643q-12-12-12-28.5t12-28.5l46-46q27-27 61-40.5t69-13.5q35 0 68.5 13.5T469-746l75 75q16 16 35 23.5t39 7.5q20 0 39.5-7.5T693-671l47-47q12-12 28.5-12t28.5 12q12 12 12 28.5T797-661l-47 47Zm0 200q-27 27-61.5 40.5T619-360q-35 0-69.5-13.5T488-414l-75-75q-15-15-34-22.5t-39-7.5q-20 0-39 7.5T267-489l-47 47q-11 11-27.5 11.5T164-442q-12-11-12.5-28t11.5-29l47-47q27-27 61-40.5t69-13.5q35 0 68.5 13.5T469-546l75 75q16 16 35 23.5t39 7.5q20 0 39.5-7.5T693-471l47-47q12-12 28.5-12t28.5 12q12 12 12 28.5T797-461l-47 47Zm-1 200q-27 27-61 40.5T619-160q-35 0-69.5-13.5T488-214l-76-75q-15-15-34-22.5t-39-7.5q-20 0-39 7.5T266-289l-47 47q-11 11-27.5 11.5T163-242q-11-11-11-28t11-28l47-48q27-27 61-40.5t69-13.5q35 0 68.5 13.5T469-346l75 75q16 16 35.5 23.5T619-240q20 0 39-7.5t35-23.5l47-47q12-12 28-11.5t28 12.5q11 12 11.5 28T796-261l-47 47Z"
      fill="currentColor"
    />
  </Icon>
);

export const DryAcStorageIcon = (props: IconProps) => (
  <Icon
    as="svg"
    viewBox="0 -960 960 960"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M424-80q-51 0-77.5-30.5T320-180q0-26 11.5-50.5T367-271q22-14 35.5-36t18.5-47l-12-6q-6-3-11-7l-92 33q-17 6-33 10t-33 4q-63 0-111.5-55T80-536q0-51 30.5-77.5T179-640q26 0 51 11.5t41 35.5q14 22 36 35.5t47 18.5l6-12q3-6 7-11l-33-92q-6-17-10-33t-4-32q0-64 55-112.5T536-880q51 0 77.5 30.5T640-781q0 26-11.5 51T593-689q-22 14-35.5 36T539-606l12 6q6 3 11 7l92-34q17-6 32.5-9.5T719-640q81 0 121 67t40 149q0 51-32 77.5T777-320q-25 0-48.5-11.5T689-367q-14-22-36-35.5T606-421l-6 12q-3 6-7 11l33 92q6 16 10 30.5t4 30.5q1 65-54 115T424-80Zm56-340q25 0 42.5-17.5T540-480q0-25-17.5-42.5T480-540q-25 0-42.5 17.5T420-480q0 25 17.5 42.5T480-420Z"
      fill="currentColor"
    />
  </Icon>
);
